import { VERTICALS } from '@weather-story/vertical-config';
import { useState } from 'react';
import { useVertical } from '../contexts/VerticalContext';

/**
 * Floating dev-only dropdown for switching between verticals on localhost.
 * Navigates to ?v=<id> which triggers a full page reload so routes re-resolve.
 * Only rendered when import.meta.env.DEV is true.
 */
export function DevVerticalSwitcher() {
  const current = useVertical();
  const [open, setOpen] = useState(false);

  const verticals = Object.values(VERTICALS);

  function switchTo(id: string) {
    const url = new URL(window.location.href);
    url.searchParams.set('v', id);
    window.location.assign(url.toString());
  }

  return (
    <div className="fixed bottom-4 right-4 z-[9999]">
      {open && (
        <div className="mb-2 bg-gray-800 border border-gray-600 rounded-lg shadow-xl overflow-hidden min-w-[200px]">
          <div className="px-3 py-2 text-xs text-gray-400 border-b border-gray-700 font-medium">
            Switch Vertical
          </div>
          {verticals.map((v) => (
            <button
              key={v.id}
              onClick={() => switchTo(v.id)}
              className={`w-full text-left px-3 py-2 text-sm flex items-center gap-2 transition-colors ${
                v.id === current.id
                  ? 'bg-gray-700 text-white'
                  : 'text-gray-300 hover:bg-gray-700/50 hover:text-white'
              }`}
            >
              <span
                className="w-3 h-3 rounded-full flex-shrink-0"
                style={{ backgroundColor: v.theme.primary[500] }}
              />
              <span className="font-medium">{v.name}</span>
              <span className="text-gray-500 text-xs ml-auto">{v.domain}</span>
              {v.id === current.id && <span className="text-xs text-green-400">*</span>}
            </button>
          ))}
        </div>
      )}
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium shadow-lg transition-all hover:scale-105"
        style={{
          backgroundColor: current.theme.primary[500],
          color: 'white',
        }}
      >
        <span className="w-2 h-2 rounded-full bg-white/30" />
        {current.name}
        <svg
          className={`w-3 h-3 transition-transform ${open ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
        </svg>
      </button>
    </div>
  );
}
